import dayjs from '@/lib/dayjs'
import type { Dayjs } from 'dayjs'

export function getOrganizationNow(organizationTimezone?: string | null): Dayjs {
  return organizationTimezone ? dayjs().tz(organizationTimezone) : dayjs()
}
